module.exports = __webpack_public_path__ + "static/image_3-d616ad8d24caa99ad6d137f7b9f928a0.jpg";